(() => {
  const init = (root) => {
    root.querySelectorAll('[data-autoscroll]').forEach((track) => {
      if (track.dataset.asReady === 'true') return;
      const items = [...track.children].filter((el) => el.nodeType === 1);
      if (items.length < 2) return;
      track.dataset.asReady = 'true';
      // Boucle sans coupure : on duplique une fois les cartes
      items.forEach((el) => {
        const c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('a, button, input, video[controls]').forEach((x) => x.setAttribute('tabindex', '-1'));
        track.appendChild(c);
      });
      const viewport = document.createElement('div');
      viewport.className = 'as-viewport' + (track.hasAttribute('data-autoscroll-full') ? ' as-viewport--full' : '');
      track.parentNode.insertBefore(viewport, track);
      viewport.appendChild(track);
      track.classList.add('as-track');
      track.style.setProperty('--as-speed', (parseFloat(track.dataset.autoscroll) || 40) + 's');
    });
  };
  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
